import PINPEO from './palette';

const typography = {
  fontFamily: PINPEO.fontFamily,
  h1: {
    fontWeight: 700,
    fontSize: 35,
    letterSpacing: '-0.02em',
  },
  h2: {
    fontWeight: 700,
    fontSize: 29,
    letterSpacing: '-0.02em',
  },
  h3: {
    fontWeight: 700,
    fontSize: 24,
    letterSpacing: '-0.01em',
  },
  h4: {
    fontWeight: 700,
    fontSize: 20,
    letterSpacing: '-0.01em',
  },
  h5: {
    fontWeight: 600,
    fontSize: 16,
    letterSpacing: '-0.01em',
  },
  h6: {
    fontWeight: 600,
    fontSize: 14,
    letterSpacing: '-0.01em',
  },
  overline: {
    fontWeight: 600,
    letterSpacing: '0.06em',
  },
};

export default typography;
